import React, { useState, useRef } from 'react';
import logo from '../assets/logo.png';

const Header = ({ onVasZahtevClick, onProdajaClick, onIzdavanjeClick, onAboutClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const headerRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header
      ref={headerRef}
      className="fixed top-0 left-0 w-full bg-gray-900 text-white shadow-lg z-50 flex justify-between items-center px-6 h-20 md:h-24 lg:h-28 transition-colors duration-300"
    >
      {/* Logo */}
      <div className="flex items-center">
<img src={logo} alt="Logo" className="h-16 md:h-20 lg:h-24 w-auto" />
      </div>

      {/* Hamburger menu za male ekrane */}
      <div className="ml-auto md:hidden">
        <button onClick={toggleMenu} className="text-white focus:outline-none">
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}
            />
          </svg>
        </button>
      </div>

      {/* Navigacija */}
      <nav
        className={`${
          isMenuOpen ? 'block' : 'hidden'
        } md:flex md:gap-8 absolute md:static top-20 left-0 w-full bg-gray-900 md:bg-transparent text-center md:text-right md:w-auto`}
      >
        <ul className="flex flex-col md:flex-row md:gap-8 items-center w-full md:w-auto">
          <li>
            <button
              onClick={() => {
                onAboutClick();
                closeMenu(); // Zatvara meni na mobilnim uređajima
              }}
              className="block py-4 md:py-2 px-4 border border-transparent hover:bg-pink-500 hover:text-black hover:border-pink-500 hover:rounded transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_10px_3px_rgba(219,39,119,1)]"
            >
              Pocetna
            </button>
          </li>
          <li>
            <button
              onClick={() => {
                onProdajaClick();
                closeMenu(); // Zatvara meni na mobilnim uređajima
              }}
              className="block py-4 md:py-2 px-4 border border-transparent hover:bg-pink-500 hover:text-black hover:border-pink-500 hover:rounded transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_10px_3px_rgba(219,39,119,1)]"
            >
              Prodaja
            </button>
          </li>
          <li>
            <button
              onClick={() => {
                onIzdavanjeClick();
                closeMenu(); // Zatvara meni na mobilnim uređajima
              }}
              className="block py-4 md:py-2 px-4 border border-transparent hover:bg-pink-500 hover:text-black hover:border-pink-500 hover:rounded transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_10px_3px_rgba(219,39,119,1)]"
            >
              Izdavanje
            </button>
          </li>
          <li>
            <button
              onClick={() => {
                onVasZahtevClick();
                closeMenu(); // Zatvara meni na mobilnim uređajima
              }}
              className="block py-4 md:py-2 px-4 border border-transparent hover:bg-pink-500 hover:text-black hover:border-pink-500 hover:rounded transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_10px_3px_rgba(219,39,119,1)]"
            >
              Vaš Zahtev
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
